module.exports = {"life_habit":"This life habit is","help_used":"Help type used","difficulty_level":"Difficulty level","satisfaction_level":"Satisfaction level"}


//////////////////
// WEBPACK FOOTER
// ./resources/js/lang/en/header/category.json
// module id = j1z/
// module chunks = 25